// Logos
// 1
import Award_1_Prize_1x from "./../assets/AwardsPage/Logos/Award_1_Prize/Award_1_Prize_1x.webp";
import Award_1_Prize_2x from "./../assets/AwardsPage/Logos/Award_1_Prize/Award_1_Prize_2x.webp";
import Award_1_Prize_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_1_Prize/Award_1_Prize_1x.webp";
import Award_1_Prize_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_1_Prize/Award_1_Prize_2x.webp";

// 2
import Award_2_Prize_1x from "./../assets/AwardsPage/Logos/Award_2_Prize/Award_2_Prize_1x.webp";
import Award_2_Prize_2x from "./../assets/AwardsPage/Logos/Award_2_Prize/Award_2_Prize_2x.webp";
import Award_2_Prize_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_2_Prize/Award_2_Prize_1x.webp";
import Award_2_Prize_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_2_Prize/Award_2_Prize_2x.webp";

// 3
import Award_3_Prize_1x from "./../assets/AwardsPage/Logos/Award_3_Prize/Award_3_Prize_1x.webp";
import Award_3_Prize_2x from "./../assets/AwardsPage/Logos/Award_3_Prize/Award_3_Prize_2x.webp";
import Award_3_Prize_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_3_Prize/Award_3_Prize_1x.webp";
import Award_3_Prize_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_3_Prize/Award_3_Prize_2x.webp";

// 4
import Award_API_Anchor_Award_1x from "./../assets/AwardsPage/Logos/Award_API_Anchor_Award/Award_API_Anchor_Award_1x.webp";
import Award_API_Anchor_Award_2x from "./../assets/AwardsPage/Logos/Award_API_Anchor_Award/Award_API_Anchor_Award_2x.webp";
import Award_API_Anchor_Award_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_API_Anchor_Award/Award_API_Anchor_Award_1x.webp";
import Award_API_Anchor_Award_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_API_Anchor_Award/Award_API_Anchor_Award_2x.webp";

// 5
import Award_Best_Employee_1x from "./../assets/AwardsPage/Logos/Award_Best_Employee/Award_Best_Employee_1x.webp";
import Award_Best_Employee_2x from "./../assets/AwardsPage/Logos/Award_Best_Employee/Award_Best_Employee_2x.webp";
import Award_Best_Employee_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Best_Employee/Award_Best_Employee_1x.webp";
import Award_Best_Employee_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Best_Employee/Award_Best_Employee_2x.webp";

// 6
import Award_Consolation_Prize_1x from "./../assets/AwardsPage/Logos/Award_Consolation_Prize/Award_Consolation_Prize_1x.webp";
import Award_Consolation_Prize_2x from "./../assets/AwardsPage/Logos/Award_Consolation_Prize/Award_Consolation_Prize_2x.webp";
import Award_Consolation_Prize_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Consolation_Prize/Award_Consolation_Prize_1x.webp";
import Award_Consolation_Prize_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Consolation_Prize/Award_Consolation_Prize_2x.webp";

// 7
import Award_Contextual_Master_Award_1x from "./../assets/AwardsPage/Logos/Award_Contextual_Master_Award/Award_Contextual_Master_Award_1x.webp";
import Award_Contextual_Master_Award_2x from "./../assets/AwardsPage/Logos/Award_Contextual_Master_Award/Award_Contextual_Master_Award_2x.webp";
import Award_Contextual_Master_Award_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Contextual_Master_Award/Award_Contextual_Master_Award_1x.webp";
import Award_Contextual_Master_Award_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Contextual_Master_Award/Award_Contextual_Master_Award_2x.webp";

// 8
import Award_Golden_Guru_1x from "./../assets/AwardsPage/Logos/Award_Golden_Guru/Award_Golden_Guru_1x.webp";
import Award_Golden_Guru_2x from "./../assets/AwardsPage/Logos/Award_Golden_Guru/Award_Golden_Guru_2x.webp";
import Award_Golden_Guru_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Golden_Guru/Award_Golden_Guru_1x.webp";
import Award_Golden_Guru_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Golden_Guru/Award_Golden_Guru_2x.webp";

// 9
import Award_Participation_1x from "./../assets/AwardsPage/Logos/Award_Participation/Award_Participation_1x.webp";
import Award_Participation_2x from "./../assets/AwardsPage/Logos/Award_Participation/Award_Participation_2x.webp";
import Award_Participation_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Participation/Award_Participation_1x.webp";
import Award_Participation_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Participation/Award_Participation_2x.webp";

// 10
import Award_Silver_Certified_Mentor_1x from "./../assets/AwardsPage/Logos/Award_Silver_Certified_Mentor/Award_Silver_Certified_Mentor_1x.webp";
import Award_Silver_Certified_Mentor_2x from "./../assets/AwardsPage/Logos/Award_Silver_Certified_Mentor/Award_Silver_Certified_Mentor_2x.webp";
import Award_Silver_Certified_Mentor_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Silver_Certified_Mentor/Award_Silver_Certified_Mentor_1x.webp";
import Award_Silver_Certified_Mentor_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Silver_Certified_Mentor/Award_Silver_Certified_Mentor_2x.webp";

// 11
import Award_Special_Initiative_Award_1x from "./../assets/AwardsPage/Logos/Award_Special_Initiative_Award/Award_Special_Initiative_Award_1x.webp";
import Award_Special_Initiative_Award_2x from "./../assets/AwardsPage/Logos/Award_Special_Initiative_Award/Award_Special_Initiative_Award_2x.webp";
import Award_Special_Initiative_Award_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Special_Initiative_Award/Award_Special_Initiative_Award_1x.webp";
import Award_Special_Initiative_Award_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Special_Initiative_Award/Award_Special_Initiative_Award_2x.webp";

// 12
import EEE_Expo_24_Award_1x from "./../assets/AwardsPage/Logos/EEE_Expo_24_Award/EEE_Expo_24_Award_1x.webp";
import EEE_Expo_24_Award_2x from "./../assets/AwardsPage/Logos/EEE_Expo_24_Award/EEE_Expo_24_Award_2x.webp";
import EEE_Expo_24_Award_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_EEE_Expo_24/Award_EEE_Expo_24_1x.webp";
import EEE_Expo_24_Award_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_EEE_Expo_24/Award_EEE_Expo_24_2x.webp";

// 13
import Award_Event_Management_1x from "./../assets/AwardsPage/Logos/Award_Event_Management/Award_Event_Management_1x.webp";
import Award_Event_Management_2x from "./../assets/AwardsPage/Logos/Award_Event_Management/Award_Event_Management_2x.webp";
import Award_Event_Management_M1x from "./../assets/AwardsPage/Logos/0Mobile/Award_Event_Management/Award_Event_Management_1x.webp";
import Award_Event_Management_M2x from "./../assets/AwardsPage/Logos/0Mobile/Award_Event_Management/Award_Event_Management_2x.webp";

// Award Certificates
// 1
import GoldenGuruCertificate_1x from "./../assets/AwardsPage/Certificates/1GoldenGuruCertificate/GoldenGuruCertificate_1x.webp";
import GoldenGuruCertificate_2x from "./../assets/AwardsPage/Certificates/1GoldenGuruCertificate/GoldenGuruCertificate_2x.webp";
import GoldenGuruCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/1GoldenGuruCertificate/GoldenGuruCertificate_1x.webp";
import GoldenGuruCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/1GoldenGuruCertificate/GoldenGuruCertificate_2x.webp";

// 2
import TCSExpo24TrophyPhoto_1x from "./../assets/AwardsPage/Certificates/2TCSExpo24TrophyPhoto/TCSExpo24TrophyPhoto_1x.webp";
import TCSExpo24TrophyPhoto_2x from "./../assets/AwardsPage/Certificates/2TCSExpo24TrophyPhoto/TCSExpo24TrophyPhoto_2x.webp";
import TCSExpo24TrophyPhoto_M1x from "./../assets/AwardsPage/Certificates/0Mobile/2TCSExpo24TrophyPhoto/TCSExpo24TrophyPhoto_1x.webp";
import TCSExpo24TrophyPhoto_M2x from "./../assets/AwardsPage/Certificates/0Mobile/2TCSExpo24TrophyPhoto/TCSExpo24TrophyPhoto_2x.webp";

// 3
import ContextualMasterCertificate_1x from "./../assets/AwardsPage/Certificates/3ContextualMasterCertificate/ContextualMasterCertificate_1x.webp";
import ContextualMasterCertificate_2x from "./../assets/AwardsPage/Certificates/3ContextualMasterCertificate/ContextualMasterCertificate_2x.webp";
import ContextualMasterCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/3ContextualMasterCertificate/ContextualMasterCertificate_1x.webp";
import ContextualMasterCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/3ContextualMasterCertificate/ContextualMasterCertificate_2x.webp";

// 4
import SilverCertifiedMentorCertificate_1x from "./../assets/AwardsPage/Certificates/4SilverCertifiedMentorCertificate/SilverCertifiedMentorCertificate_1x.webp";
import SilverCertifiedMentorCertificate_2x from "./../assets/AwardsPage/Certificates/4SilverCertifiedMentorCertificate/SilverCertifiedMentorCertificate_2x.webp";
import SilverCertifiedMentorCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/4SilverCertifiedMentorCertificate/SilverCertifiedMentorCertificate_1x.webp";
import SilverCertifiedMentorCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/4SilverCertifiedMentorCertificate/SilverCertifiedMentorCertificate_2x.webp";

// 5
import SpecialInitiativeAwardCertificate_1x from "./../assets/AwardsPage/Certificates/5SpecialInitiativeAwardCertificate/SpecialInitiativeAwardCertificate_1x.webp";
import SpecialInitiativeAwardCertificate_2x from "./../assets/AwardsPage/Certificates/5SpecialInitiativeAwardCertificate/SpecialInitiativeAwardCertificate_2x.webp";
import SpecialInitiativeAwardCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/5SpecialInitiativeAwardCertificate/SpecialInitiativeAwardCertificate_1x.webp";
import SpecialInitiativeAwardCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/5SpecialInitiativeAwardCertificate/SpecialInitiativeAwardCertificate_2x.webp";

// 6
import AcademicAnchorAwardCertificate_1x from "./../assets/AwardsPage/Certificates/6AcademicAnchorAwardCertificate/AcademicAnchorAwardCertificate_1x.webp";
import AcademicAnchorAwardCertificate_2x from "./../assets/AwardsPage/Certificates/6AcademicAnchorAwardCertificate/AcademicAnchorAwardCertificate_2x.webp";
import AcademicAnchorAwardCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/6AcademicAnchorAwardCertificate/AcademicAnchorAwardCertificate_1x.webp";
import AcademicAnchorAwardCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/6AcademicAnchorAwardCertificate/AcademicAnchorAwardCertificate_2x.webp";

// 7
import BestEmployeeAwardCertificate_1x from "./../assets/AwardsPage/Certificates/7BestEmployeeAwardCertificate/BestEmployeeAwardCertificate_1x.webp";
import BestEmployeeAwardCertificate_2x from "./../assets/AwardsPage/Certificates/7BestEmployeeAwardCertificate/BestEmployeeAwardCertificate_2x.webp";
import BestEmployeeAwardCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/7BestEmployeeAwardCertificate/BestEmployeeAwardCertificate_1x.webp";
import BestEmployeeAwardCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/7BestEmployeeAwardCertificate/BestEmployeeAwardCertificate_2x.webp";

// 8
import WinnerAppsForAsiaCertificate_1x from "./../assets/AwardsPage/Certificates/8WinnerAppsForAsiaCertificate/WinnerAppsForAsiaCertificate_1x.webp";
import WinnerAppsForAsiaCertificate_2x from "./../assets/AwardsPage/Certificates/8WinnerAppsForAsiaCertificate/WinnerAppsForAsiaCertificate_2x.webp";
import WinnerAppsForAsiaCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/8WinnerAppsForAsiaCertificate/WinnerAppsForAsiaCertificate_1x.webp";
import WinnerAppsForAsiaCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/8WinnerAppsForAsiaCertificate/WinnerAppsForAsiaCertificate_2x.webp";

// 9
import WinnerAppFestPuneCertificate_1x from "./../assets/AwardsPage/Certificates/9WinnerAppFestPuneCertificate/WinnerAppFestPuneCertificate_1x.webp";
import WinnerAppFestPuneCertificate_2x from "./../assets/AwardsPage/Certificates/9WinnerAppFestPuneCertificate/WinnerAppFestPuneCertificate_2x.webp";
import WinnerAppFestPuneCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/9WinnerAppFestPuneCertificate/WinnerAppFestPuneCertificate_1x.webp";
import WinnerAppFestPuneCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/9WinnerAppFestPuneCertificate/WinnerAppFestPuneCertificate_2x.webp";

// 10
import FirstProjectUtsav11Certificate_1x from "./../assets/AwardsPage/Certificates/10FirstProjectUtsav11Certificate/FirstProjectUtsav11Certificate_1x.webp";
import FirstProjectUtsav11Certificate_2x from "./../assets/AwardsPage/Certificates/10FirstProjectUtsav11Certificate/FirstProjectUtsav11Certificate_2x.webp";
import FirstProjectUtsav11Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/10FirstProjectUtsav11Certificate/FirstProjectUtsav11Certificate_1x.webp";
import FirstProjectUtsav11Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/10FirstProjectUtsav11Certificate/FirstProjectUtsav11Certificate_2x.webp";

// 11
import FirstCTechnowar10Certificate_1x from "./../assets/AwardsPage/Certificates/11FirstCTechnowar10Certificate/FirstCTechnowar10Certificate_1x.webp";
import FirstCTechnowar10Certificate_2x from "./../assets/AwardsPage/Certificates/11FirstCTechnowar10Certificate/FirstCTechnowar10Certificate_2x.webp";
import FirstCTechnowar10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/11FirstCTechnowar10Certificate/FirstCTechnowar10Certificate_1x.webp";
import FirstCTechnowar10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/11FirstCTechnowar10Certificate/FirstCTechnowar10Certificate_2x.webp";

// 12
import FirstProjectUtsav10Certificate_1x from "./../assets/AwardsPage/Certificates/12FirstProjectUtsav10Certificate/FirstProjectUtsav10Certificate_1x.webp";
import FirstProjectUtsav10Certificate_2x from "./../assets/AwardsPage/Certificates/12FirstProjectUtsav10Certificate/FirstProjectUtsav10Certificate_2x.webp";
import FirstProjectUtsav10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/12FirstProjectUtsav10Certificate/FirstProjectUtsav10Certificate_1x.webp";
import FirstProjectUtsav10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/12FirstProjectUtsav10Certificate/FirstProjectUtsav10Certificate_2x.webp";

// 13
import SecondWebITiazza10Certificate_1x from "./../assets/AwardsPage/Certificates/13SecondWebITiazza10Certificate/SecondWebITiazza10Certificate_1x.webp";
import SecondWebITiazza10Certificate_2x from "./../assets/AwardsPage/Certificates/13SecondWebITiazza10Certificate/SecondWebITiazza10Certificate_2x.webp";
import SecondWebITiazza10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/13SecondWebITiazza10Certificate/SecondWebITiazza10Certificate_1x.webp";
import SecondWebITiazza10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/13SecondWebITiazza10Certificate/SecondWebITiazza10Certificate_2x.webp";

// 14
import ThirdCITiazza10Certificate_1x from "./../assets/AwardsPage/Certificates/14ThirdCITiazza10Certificate/ThirdCITiazza10Certificate_1x.webp";
import ThirdCITiazza10Certificate_2x from "./../assets/AwardsPage/Certificates/14ThirdCITiazza10Certificate/ThirdCITiazza10Certificate_2x.webp";
import ThirdCITiazza10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/14ThirdCITiazza10Certificate/ThirdCITiazza10Certificate_1x.webp";
import ThirdCITiazza10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/14ThirdCITiazza10Certificate/ThirdCITiazza10Certificate_2x.webp";

// 15
import ConsolationCQuizCertificate_1x from "./../assets/AwardsPage/Certificates/15ConsolationCQuizCertificate/ConsolationCQuizCertificate_1x.webp";
import ConsolationCQuizCertificate_2x from "./../assets/AwardsPage/Certificates/15ConsolationCQuizCertificate/ConsolationCQuizCertificate_2x.webp";
import ConsolationCQuizCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/15ConsolationCQuizCertificate/ConsolationCQuizCertificate_1x.webp";
import ConsolationCQuizCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/15ConsolationCQuizCertificate/ConsolationCQuizCertificate_2x.webp";

// 16
import EventManagementTechnoWar10Certificate_1x from "./../assets/AwardsPage/Certificates/16EventManagementTechnoWar10Certificate/EventManagementTechnoWar10Certificate_1x.webp";
import EventManagementTechnoWar10Certificate_2x from "./../assets/AwardsPage/Certificates/16EventManagementTechnoWar10Certificate/EventManagementTechnoWar10Certificate_2x.webp";
import EventManagementTechnoWar10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/16EventManagementTechnoWar10Certificate/EventManagementTechnoWar10Certificate_1x.webp";
import EventManagementTechnoWar10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/16EventManagementTechnoWar10Certificate/EventManagementTechnoWar10Certificate_2x.webp";

// 17
import ParticipationTechnoCrat10MITPuneCertificate_1x from "./../assets/AwardsPage/Certificates/17ParticipationTechnoCrat10MITPuneCertificate/ParticipationTechnoCrat10MITPuneCertificate_1x.webp";
import ParticipationTechnoCrat10MITPuneCertificate_2x from "./../assets/AwardsPage/Certificates/17ParticipationTechnoCrat10MITPuneCertificate/ParticipationTechnoCrat10MITPuneCertificate_2x.webp";
import ParticipationTechnoCrat10MITPuneCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/17ParticipationTechnoCrat10MITPuneCertificate/ParticipationTechnoCrat10MITPuneCertificate_1x.webp";
import ParticipationTechnoCrat10MITPuneCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/17ParticipationTechnoCrat10MITPuneCertificate/ParticipationTechnoCrat10MITPuneCertificate_2x.webp";

// 18
import ParticipationProjectITFesta10JalgaonCertificate_1x from "./../assets/AwardsPage/Certificates/18ParticipationProjectITFesta10JalgaonCertificate/ParticipationProjectITFesta10JalgaonCertificate_1x.webp";
import ParticipationProjectITFesta10JalgaonCertificate_2x from "./../assets/AwardsPage/Certificates/18ParticipationProjectITFesta10JalgaonCertificate/ParticipationProjectITFesta10JalgaonCertificate_2x.webp";
import ParticipationProjectITFesta10JalgaonCertificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/18ParticipationProjectITFesta10JalgaonCertificate/ParticipationProjectITFesta10JalgaonCertificate_1x.webp";
import ParticipationProjectITFesta10JalgaonCertificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/18ParticipationProjectITFesta10JalgaonCertificate/ParticipationProjectITFesta10JalgaonCertificate_2x.webp";

// 19
import ParticipationJavaWorkshop11Certificate_1x from "./../assets/AwardsPage/Certificates/19ParticipationJavaWorkshop11Certificate/ParticipationJavaWorkshop11Certificate_1x.webp";
import ParticipationJavaWorkshop11Certificate_2x from "./../assets/AwardsPage/Certificates/19ParticipationJavaWorkshop11Certificate/ParticipationJavaWorkshop11Certificate_2x.webp";
import ParticipationJavaWorkshop11Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/19ParticipationJavaWorkshop11Certificate/ParticipationJavaWorkshop11Certificate_1x.webp";
import ParticipationJavaWorkshop11Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/19ParticipationJavaWorkshop11Certificate/ParticipationJavaWorkshop11Certificate_2x.webp";

// 20
import ParticipationMicrocontroller10Certificate_1x from "./../assets/AwardsPage/Certificates/20ParticipationMicrocontroller10Certificate/ParticipationMicrocontroller10Certificate_1x.webp";
import ParticipationMicrocontroller10Certificate_2x from "./../assets/AwardsPage/Certificates/20ParticipationMicrocontroller10Certificate/ParticipationMicrocontroller10Certificate_2x.webp";
import ParticipationMicrocontroller10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/20ParticipationMicrocontroller10Certificate/ParticipationMicrocontroller10Certificate_1x.webp";
import ParticipationMicrocontroller10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/20ParticipationMicrocontroller10Certificate/ParticipationMicrocontroller10Certificate_2x.webp";

// 21
import ParticipationProjectImpact09Certificate_1x from "./../assets/AwardsPage/Certificates/21ParticipationProjectImpact09Certificate/ParticipationProjectImpact09Certificate_1x.webp";
import ParticipationProjectImpact09Certificate_2x from "./../assets/AwardsPage/Certificates/21ParticipationProjectImpact09Certificate/ParticipationProjectImpact09Certificate_2x.webp";
import ParticipationProjectImpact09Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/21ParticipationProjectImpact09Certificate/ParticipationProjectImpact09Certificate_1x.webp";
import ParticipationProjectImpact09Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/21ParticipationProjectImpact09Certificate/ParticipationProjectImpact09Certificate_2x.webp";

// 22
import ParticipationProjectImpact10Certificate_1x from "./../assets/AwardsPage/Certificates/22ParticipationProjectImpact10Certificate/ParticipationProjectImpact10Certificate_1x.webp";
import ParticipationProjectImpact10Certificate_2x from "./../assets/AwardsPage/Certificates/22ParticipationProjectImpact10Certificate/ParticipationProjectImpact10Certificate_2x.webp";
import ParticipationProjectImpact10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/22ParticipationProjectImpact10Certificate/ParticipationProjectImpact10Certificate_1x.webp";
import ParticipationProjectImpact10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/22ParticipationProjectImpact10Certificate/ParticipationProjectImpact10Certificate_2x.webp";

// 23
import ParticipationProjectKshitij10Certificate_1x from "./../assets/AwardsPage/Certificates/23ParticipationProjectKshitij10Certificate/ParticipationProjectKshitij10Certificate_1x.webp";
import ParticipationProjectKshitij10Certificate_2x from "./../assets/AwardsPage/Certificates/23ParticipationProjectKshitij10Certificate/ParticipationProjectKshitij10Certificate_2x.webp";
import ParticipationProjectKshitij10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/23ParticipationProjectKshitij10Certificate/ParticipationProjectKshitij10Certificate_1x.webp";
import ParticipationProjectKshitij10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/23ParticipationProjectKshitij10Certificate/ParticipationProjectKshitij10Certificate_2x.webp";

// 24
import ParticipationCTechnoWar10Certificate_1x from "./../assets/AwardsPage/Certificates/24ParticipationCTechnoWar10Certificate/ParticipationCTechnoWar10Certificate_1x.webp";
import ParticipationCTechnoWar10Certificate_2x from "./../assets/AwardsPage/Certificates/24ParticipationCTechnoWar10Certificate/ParticipationCTechnoWar10Certificate_2x.webp";
import ParticipationCTechnoWar10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/24ParticipationCTechnoWar10Certificate/ParticipationCTechnoWar10Certificate_1x.webp";
import ParticipationCTechnoWar10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/24ParticipationCTechnoWar10Certificate/ParticipationCTechnoWar10Certificate_2x.webp";

// 25
import ParticipationCTechnoWar11Certificate_1x from "./../assets/AwardsPage/Certificates/25ParticipationCTechnoWar11Certificate/ParticipationCTechnoWar11Certificate_1x.webp";
import ParticipationCTechnoWar11Certificate_2x from "./../assets/AwardsPage/Certificates/25ParticipationCTechnoWar11Certificate/ParticipationCTechnoWar11Certificate_2x.webp";
import ParticipationCTechnoWar11Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/25ParticipationCTechnoWar11Certificate/ParticipationCTechnoWar11Certificate_1x.webp";
import ParticipationCTechnoWar11Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/25ParticipationCTechnoWar11Certificate/ParticipationCTechnoWar11Certificate_2x.webp";

// 26
import ParticipationPaperPresentation10Certificate_1x from "./../assets/AwardsPage/Certificates/26ParticipationPaperPresentation10Certificate/ParticipationPaperPresentation10Certificate_1x.webp";
import ParticipationPaperPresentation10Certificate_2x from "./../assets/AwardsPage/Certificates/26ParticipationPaperPresentation10Certificate/ParticipationPaperPresentation10Certificate_2x.webp";
import ParticipationPaperPresentation10Certificate_M1x from "./../assets/AwardsPage/Certificates/0Mobile/26ParticipationPaperPresentation10Certificate/ParticipationPaperPresentation10Certificate_1x.webp";
import ParticipationPaperPresentation10Certificate_M2x from "./../assets/AwardsPage/Certificates/0Mobile/26ParticipationPaperPresentation10Certificate/ParticipationPaperPresentation10Certificate_2x.webp";

// 27
import METPrinipalAppreciation_1x from "./../assets/AwardsPage/Certificates/27METPrinipalAppreciation/METPrinipalAppreciation_1x.webp";
import METPrinipalAppreciation_2x from "./../assets/AwardsPage/Certificates/27METPrinipalAppreciation/METPrinipalAppreciation_2x.webp";
import METPrinipalAppreciation_M1x from "./../assets/AwardsPage/Certificates/0Mobile/27METPrinipalAppreciation/METPrinipalAppreciation_1x.webp";
import METPrinipalAppreciation_M2x from "./../assets/AwardsPage/Certificates/0Mobile/27METPrinipalAppreciation/METPrinipalAppreciation_2x.webp";

import ListPage from "../components/List/List";

import { useEffect } from "react";

export default function AwardsPage() {
  async function setPageHitsOnDB() {
    const url =
      "https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataAwardsPage.json";
    try {
      const response = await fetch(url);
      if (response.ok) {
        const json = await response.json();

        fetch(url, {
          method: "PUT",
          body: JSON.stringify({ pageHits: +json.pageHits + 1 }),
        });
      }
    } catch (error) {
      // console.error(error.message);
    }
  }

  useEffect(() => {
    setPageHitsOnDB();
  }, []);

  // Set Page Data
  const data = [
    // 1
    {
      id: 1,
      card: {
        date: "25 APR 2024",
        title: "TCS Golden Guru Gala Award 2024",
        subText: "Nagpur | TATA Consultancy Services",
        image1x: Award_Golden_Guru_1x,
        image2x: Award_Golden_Guru_2x,
        imageM1x: Award_Golden_Guru_M1x,
        imageM2x: Award_Golden_Guru_M2x,
        alt: "TCS Golden Guru Gala Award 2024",
      },
      popup: [
        {
          id: 1,
          image1x: GoldenGuruCertificate_1x,
          image2x: GoldenGuruCertificate_2x,
          imageM1x: GoldenGuruCertificate_M1x,
          imageM2x: GoldenGuruCertificate_M2x,
          alt: "Golden Guru Certificate",
        },
      ],
    },
    // 2
    {
      id: 2,
      card: {
        date: "5 SEP 2024",
        title: "Choice of the Engineer’s Award",
        subText: "Nagpur | Engineering Excellence Expo 2024, TCS",
        image1x: EEE_Expo_24_Award_1x,
        image2x: EEE_Expo_24_Award_2x,
        imageM1x: EEE_Expo_24_Award_M1x,
        imageM2x: EEE_Expo_24_Award_M2x,
        alt: "Choice of the Engineer’s Award",
      },
      popup: [
        {
          id: 1,
          image1x: TCSExpo24TrophyPhoto_1x,
          image2x: TCSExpo24TrophyPhoto_2x,
          imageM1x: TCSExpo24TrophyPhoto_M1x,
          imageM2x: TCSExpo24TrophyPhoto_M2x,
          alt: "Choice of the Engineer’s Award Certificate",
        },
      ],
    },
    // 3
    {
      id: 3,
      card: {
        date: "5 jun 2024",
        title: "TCS Contextual Master Award",
        subText: "Nagpur | TATA Consultancy Services",
        image1x: Award_Contextual_Master_Award_1x,
        image2x: Award_Contextual_Master_Award_2x,
        imageM1x: Award_Contextual_Master_Award_M1x,
        imageM2x: Award_Contextual_Master_Award_M2x,
        alt: "TCS Contextual Master Award",
      },
      popup: [
        {
          id: 1,
          image1x: ContextualMasterCertificate_1x,
          image2x: ContextualMasterCertificate_2x,
          imageM1x: ContextualMasterCertificate_M1x,
          imageM2x: ContextualMasterCertificate_M2x,
          alt: "Contextual Master Certificate",
        },
      ],
    },
    // 4
    {
      id: 4,
      card: {
        date: "4 jun 2024",
        title: "TCS Silver Certified Mentor Award",
        subText: "Nagpur | TATA Consultancy Services",
        image1x: Award_Silver_Certified_Mentor_1x,
        image2x: Award_Silver_Certified_Mentor_2x,
        imageM1x: Award_Silver_Certified_Mentor_M1x,
        imageM2x: Award_Silver_Certified_Mentor_M2x,
        alt: "TCS Silver Certified Mentor Award",
      },
      popup: [
        {
          id: 1,
          image1x: SilverCertifiedMentorCertificate_1x,
          image2x: SilverCertifiedMentorCertificate_2x,
          imageM1x: SilverCertifiedMentorCertificate_M1x,
          imageM2x: SilverCertifiedMentorCertificate_M2x,
          alt: "Silver Certified Mentor Certificate",
        },
      ],
    },
    // 5
    {
      id: 5,
      card: {
        date: "13 oct 2023",
        title: "TCS Special Initiative Award",
        subText: "Nagpur | TATA Consultancy Services",
        image1x: Award_Special_Initiative_Award_1x,
        image2x: Award_Special_Initiative_Award_2x,
        imageM1x: Award_Special_Initiative_Award_M1x,
        imageM2x: Award_Special_Initiative_Award_M2x,
        alt: "TCS Special Initiative Award",
      },
      popup: [
        {
          id: 1,
          image1x: SpecialInitiativeAwardCertificate_1x,
          image2x: SpecialInitiativeAwardCertificate_2x,
          imageM1x: SpecialInitiativeAwardCertificate_M1x,
          imageM2x: SpecialInitiativeAwardCertificate_M2x,
          alt: "Special Initiative Award Certificate",
        },
      ],
    },
    // 6
    {
      id: 6,
      card: {
        date: "31 JUL 2023",
        title: "TCS Academic Interface Program - Anchor Award",
        subText: "Nagpur | TATA Consultancy Services",
        image1x: Award_API_Anchor_Award_1x,
        image2x: Award_API_Anchor_Award_2x,
        imageM1x: Award_API_Anchor_Award_M1x,
        imageM2x: Award_API_Anchor_Award_M2x,
        alt: "TCS Academic Interface Program - Anchor Award",
      },
      popup: [
        {
          id: 1,
          image1x: AcademicAnchorAwardCertificate_1x,
          image2x: AcademicAnchorAwardCertificate_2x,
          imageM1x: AcademicAnchorAwardCertificate_M1x,
          imageM2x: AcademicAnchorAwardCertificate_M2x,
          alt: "Academic Anchor Award Certificate",
        },
      ],
    },
    // 7
    {
      id: 7,
      card: {
        date: "26 DEC 2013",
        title: "Best Employee Award",
        subText: "Nashik | Winjit One World - Winjit Technologies Pvt. Ltd.",
        image1x: Award_Best_Employee_1x,
        image2x: Award_Best_Employee_2x,
        imageM1x: Award_Best_Employee_M1x,
        imageM2x: Award_Best_Employee_M2x,
        alt: "Best Employee Award",
      },
      popup: [
        {
          id: 1,
          image1x: BestEmployeeAwardCertificate_1x,
          image2x: BestEmployeeAwardCertificate_2x,
          imageM1x: BestEmployeeAwardCertificate_M1x,
          imageM2x: BestEmployeeAwardCertificate_M2x,
          alt: "Best Employee Award Certificate",
        },
      ],
    },
    // 8
    {
      id: 8,
      card: {
        date: "5 MAY 2013",
        title:
          "1st Prize Winner of 'Apps For Asia' Microsoft at ADB Summit 2013, Delhi",
        subText:
          "Delhi, India | Project Competition cum Exhibition - 46th Annual Meeting of The Board of Governors, Asian Development Bank Summit 2013",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "1st Prize Winner of Apps For Asia",
      },
      popup: [
        {
          id: 1,
          image1x: WinnerAppsForAsiaCertificate_1x,
          image2x: WinnerAppsForAsiaCertificate_2x,
          imageM1x: WinnerAppsForAsiaCertificate_M1x,
          imageM2x: WinnerAppsForAsiaCertificate_M2x,
          alt: "Winner Apps For Asia Certificate",
        },
      ],
    },
    // 9
    {
      id: 9,
      card: {
        date: "26 MAR 2013",
        title:
          "1st Prize Winner of AppFest at Microsoft TechEd 2013, Pune, India",
        subText: "Pune | Project Competition - Microsoft TechEd 2013",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "1st Prize Winner of AppFest at Microsoft TechEd 2013, Pune, India",
      },
      popup: [
        {
          id: 1,
          image1x: WinnerAppFestPuneCertificate_1x,
          image2x: WinnerAppFestPuneCertificate_2x,
          imageM1x: WinnerAppFestPuneCertificate_M1x,
          imageM2x: WinnerAppFestPuneCertificate_M2x,
          alt: "Winner App Fest Pune Certificate",
        },
      ],
    },
    // 10
    {
      id: 10,
      card: {
        date: "22 Jan 2011",
        title:
          "First Prize in State Level Software Project Competition cum Exhibition",
        subText: "Nashik | Utsav ‘11 - MET College of Engineering",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "First Prize in State Level Software Project Competition cum Exhibition",
      },
      popup: [
        {
          id: 1,
          image1x: FirstProjectUtsav11Certificate_1x,
          image2x: FirstProjectUtsav11Certificate_2x,
          imageM1x: FirstProjectUtsav11Certificate_M1x,
          imageM2x: FirstProjectUtsav11Certificate_M2x,
          alt: "First Project Utsav 11 Certificate",
        },
      ],
    },
    // 11
    {
      id: 11,
      card: {
        date: "14 sep 2010",
        title:
          "First Prize in C-Programming Inter College Competition - TechnoWar ‘10",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "First Prize in C-Programming Inter College Competition - TechnoWar ‘10",
      },
      popup: [
        {
          id: 1,
          image1x: FirstCTechnowar10Certificate_1x,
          image2x: FirstCTechnowar10Certificate_2x,
          imageM1x: FirstCTechnowar10Certificate_M1x,
          imageM2x: FirstCTechnowar10Certificate_M2x,
          alt: "First C Technowar 10 Certificate",
        },
      ],
    },
    // 12
    {
      id: 12,
      card: {
        date: "jan 2010",
        title:
          "First Prize in State Level Software Project Competition cum Exhibition",
        subText: "Nashik | Utsav ‘10 - MET College of Engineering",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "First Prize in State Level Software Project Competition cum Exhibition",
      },
      popup: [
        {
          id: 1,
          image1x: FirstProjectUtsav10Certificate_1x,
          image2x: FirstProjectUtsav10Certificate_2x,
          imageM1x: FirstProjectUtsav10Certificate_M1x,
          imageM2x: FirstProjectUtsav10Certificate_M2x,
          alt: "First Project Utsav 10 Certificate",
        },
      ],
    },
    // 27
    {
      id: 27,
      card: {
        date: "14 sep 2011",
        title:
          "Got Appreciation from Principal for Designing & Developing an Online Quiz Management System for Technical Event TechnoWar '11",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_1_Prize_1x,
        image2x: Award_1_Prize_2x,
        imageM1x: Award_1_Prize_M1x,
        imageM2x: Award_1_Prize_M2x,
        alt: "Frist Prize Award Logo",
      },
      popup: [
        {
          id: 1,
          image1x: METPrinipalAppreciation_1x,
          image2x: METPrinipalAppreciation_2x,
          imageM1x: METPrinipalAppreciation_M1x,
          imageM2x: METPrinipalAppreciation_M2x,
          alt: "First Project Utsav 10 Certificate",
        },
      ],
    },
    // 13
    {
      id: 13,
      card: {
        date: "6 mar 2010",
        title:
          "Second Prize in ITiazza ’10 - State Level Web Designing Competition",
        subText: "Nashik | K. K. Wagh College of Engineering",
        image1x: Award_2_Prize_1x,
        image2x: Award_2_Prize_2x,
        imageM1x: Award_2_Prize_M1x,
        imageM2x: Award_2_Prize_M2x,
        alt: "Second Prize in ITiazza ’10 - State Level Web Designing Competition",
      },
      popup: [
        {
          id: 1,
          image1x: SecondWebITiazza10Certificate_1x,
          image2x: SecondWebITiazza10Certificate_2x,
          imageM1x: SecondWebITiazza10Certificate_M1x,
          imageM2x: SecondWebITiazza10Certificate_M2x,
          alt: "Second Web ITiazza 10 Certificate",
        },
      ],
    },
    // 14
    {
      id: 14,
      card: {
        date: "6 mar 2010",
        title:
          "Third Prize in ITiazza '10 - State Level C-Programming Competition",
        subText: "Nashik | K. K. Wagh College of Engineering",
        image1x: Award_3_Prize_1x,
        image2x: Award_3_Prize_2x,
        imageM1x: Award_3_Prize_M1x,
        imageM2x: Award_3_Prize_M2x,
        alt: "Third Prize in ITiazza '10 - State Level C-Programming Competition",
      },
      popup: [
        {
          id: 1,
          image1x: ThirdCITiazza10Certificate_1x,
          image2x: ThirdCITiazza10Certificate_2x,
          imageM1x: ThirdCITiazza10Certificate_M1x,
          imageM2x: ThirdCITiazza10Certificate_M2x,
          alt: "Third C ITiazza 10 Certificate",
        },
      ],
    },
    // 15
    {
      id: 15,
      card: {
        date: "23 dec 2006",
        title:
          "Consolation Prize in C-Programming Competition - Mega Quiz 2006",
        subText: "Softaid Computers, Jalgaon",
        image1x: Award_Consolation_Prize_1x,
        image2x: Award_Consolation_Prize_2x,
        imageM1x: Award_Consolation_Prize_M1x,
        imageM2x: Award_Consolation_Prize_M2x,
        alt: "Consolation Prize in C-Programming Competition - Mega Quiz 2006",
      },
      popup: [
        {
          id: 1,
          image1x: ConsolationCQuizCertificate_1x,
          image2x: ConsolationCQuizCertificate_2x,
          imageM1x: ConsolationCQuizCertificate_M1x,
          imageM2x: ConsolationCQuizCertificate_M2x,
          alt: "Consolation C Quiz Certificate",
        },
      ],
    },
    // 16
    {
      id: 16,
      card: {
        date: "14 SEP 2010",
        title: "Award for Event Management and Co-ordination of TechnoWar 2010",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_Event_Management_1x,
        image2x: Award_Event_Management_2x,
        imageM1x: Award_Event_Management_M1x,
        imageM2x: Award_Event_Management_M2x,
        alt: "Award for Event Management and Co-ordination of TechnoWar 2010",
      },
      popup: [
        {
          id: 1,
          image1x: EventManagementTechnoWar10Certificate_1x,
          image2x: EventManagementTechnoWar10Certificate_2x,
          imageM1x: EventManagementTechnoWar10Certificate_M1x,
          imageM2x: EventManagementTechnoWar10Certificate_M2x,
          alt: "Event Management TechnoWar 10 Certificate",
        },
      ],
    },
    // 17
    {
      id: 17,
      card: {
        date: "9 jan 2010",
        title:
          "Participation in TechnoCrat 2010 - Software Project Competition",
        subText: "Pune | MIT WPU College, Pune",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in TechnoCrat 2010 - Software Project Competition",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationTechnoCrat10MITPuneCertificate_1x,
          image2x: ParticipationTechnoCrat10MITPuneCertificate_2x,
          imageM1x: ParticipationTechnoCrat10MITPuneCertificate_M1x,
          imageM2x: ParticipationTechnoCrat10MITPuneCertificate_M2x,
          alt: "Participation TechnoCrat 10 MIT Pune Certificate",
        },
      ],
    },
    // 18
    {
      id: 18,
      card: {
        date: "7 FEB 2010",
        title:
          "Participation in IT FESTA 2010 - National Level Software Project Competition",
        subText: "Jalgaon | KCE Society’s Institute of Management",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in IT FESTA 2010 - National Level Software Project Competition",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationProjectITFesta10JalgaonCertificate_1x,
          image2x: ParticipationProjectITFesta10JalgaonCertificate_2x,
          imageM1x: ParticipationProjectITFesta10JalgaonCertificate_M1x,
          imageM2x: ParticipationProjectITFesta10JalgaonCertificate_M2x,
          alt: "Participation Project ITFesta 10 Jalgaon Certificate",
        },
      ],
    },
    // 19
    {
      id: 19,
      card: {
        date: "12 mar 2011 - 18 mar 2011",
        title: "Attended Workshop on Core Java ",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Attended Workshop on Core Java ",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationJavaWorkshop11Certificate_1x,
          image2x: ParticipationJavaWorkshop11Certificate_2x,
          imageM1x: ParticipationJavaWorkshop11Certificate_M1x,
          imageM2x: ParticipationJavaWorkshop11Certificate_M2x,
          alt: "Participation Java Workshop 11 Certificate",
        },
      ],
    },
    // 20
    {
      id: 20,
      card: {
        date: "27 mar 2010",
        title:
          "Attended Workshop on Trends in Embedded System & Micro-controller",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Attended Workshop on Trends in Embedded System & Micro-controller",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationMicrocontroller10Certificate_1x,
          image2x: ParticipationMicrocontroller10Certificate_2x,
          imageM1x: ParticipationMicrocontroller10Certificate_M1x,
          imageM2x: ParticipationMicrocontroller10Certificate_M2x,
          alt: "Participation Microcontroller 10 Certificate",
        },
      ],
    },
    // 21
    {
      id: 21,
      card: {
        date: "1 FEB 2009",
        title:
          "Participation in State level Software Competition cum Exhibition - Impact '09",
        subText: "Jalgaon | KCE Society's M. J. College, Jalgaon",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in State level Software Competition cum Exhibition - Impact",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationProjectImpact09Certificate_1x,
          image2x: ParticipationProjectImpact09Certificate_2x,
          imageM1x: ParticipationProjectImpact09Certificate_M1x,
          imageM2x: ParticipationProjectImpact09Certificate_M2x,
          alt: "Participation Project Impact 09 Certificate",
        },
      ],
    },
    // 22
    {
      id: 22,
      card: {
        date: "14 feb 2010",
        title:
          "Participation in State level Software Competition cum Exhibition - Impact '10",
        subText: "Jalgaon | KCE Society's M. J. College, Jalgaon",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in State level Software Competition cum Exhibition - Impact",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationProjectImpact10Certificate_1x,
          image2x: ParticipationProjectImpact10Certificate_2x,
          imageM1x: ParticipationProjectImpact10Certificate_M1x,
          imageM2x: ParticipationProjectImpact10Certificate_M2x,
          alt: "Participation Project Impact 10 Certificate",
        },
      ],
    },
    // 23
    {
      id: 23,
      card: {
        date: "2010",
        title:
          "Participation in State level Software Competition cum Exhibition - Kshitij '10",
        subText: "Nashik | MVP College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in State level Software Competition cum Exhibition - Kshitij",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationProjectKshitij10Certificate_1x,
          image2x: ParticipationProjectKshitij10Certificate_2x,
          imageM1x: ParticipationProjectKshitij10Certificate_M1x,
          imageM2x: ParticipationProjectKshitij10Certificate_M2x,
          alt: "Participation Project Kshitij 10 Certificate",
        },
      ],
    },
    // 24
    {
      id: 24,
      card: {
        date: "14 SEP 2010",
        title: "Participation in C Programming Competition - TechnoWar 2010",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in C Programming Competition - TechnoWar 2010",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationCTechnoWar10Certificate_1x,
          image2x: ParticipationCTechnoWar10Certificate_2x,
          imageM1x: ParticipationCTechnoWar10Certificate_M1x,
          imageM2x: ParticipationCTechnoWar10Certificate_M2x,
          alt: "Participation C TechnoWar 10 Certificate",
        },
      ],
    },
    // 25
    {
      id: 25,
      card: {
        date: "14 SEP 2011",
        title: "Participation in C Programming Competition - TechnoWar 2011",
        subText: "Nashik | MET College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in C Programming Competition - TechnoWar 2011",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationCTechnoWar11Certificate_1x,
          image2x: ParticipationCTechnoWar11Certificate_2x,
          imageM1x: ParticipationCTechnoWar11Certificate_M1x,
          imageM2x: ParticipationCTechnoWar11Certificate_M2x,
          alt: "Participation C TechnoWar 11 Certificate",
        },
      ],
    },
    // 26
    {
      id: 26,
      card: {
        date: "6 Mar 2010",
        title: "Participation in Paper Presentation Competition - ITiazza ‘10",
        subText: "Nashik | K. K. Wagh College of Engineering, Nashik",
        image1x: Award_Participation_1x,
        image2x: Award_Participation_2x,
        imageM1x: Award_Participation_M1x,
        imageM2x: Award_Participation_M2x,
        alt: "Participation in Paper Presentation Competition - ITiazza ‘10",
      },
      popup: [
        {
          id: 1,
          image1x: ParticipationPaperPresentation10Certificate_1x,
          image2x: ParticipationPaperPresentation10Certificate_2x,
          imageM1x: ParticipationPaperPresentation10Certificate_M1x,
          imageM2x: ParticipationPaperPresentation10Certificate_M2x,
          alt: "Participation Paper Presentation 10 Certificate",
        },
      ],
    },
  ];

  return <ListPage pageTitle="Awards & Recognitions" data={data} />;
}
